// extracted by mini-css-extract-plugin
export default {"secondEntryTitle":"Profile_secondEntryTitle__U0Eqq","notInterestedText":"Profile_notInterestedText__ft5HS"};